import WelcomeToSession from '~/pages/default-apps/Home/components/WelcomeToSession'
import {Fragment, useRef, useState} from "react";
import { format } from "date-fns";
import TablePaging from '~/components/TablePaging';
import SupportCaseAPI from '~/api/supportCaseApi';
import {Link} from "react-router-dom";
import {CenteredModal, FormInput} from '~/components';
import {useForm} from "react-hook-form";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import {toast} from "react-toastify";
const tablePagingConfig = {
    columns: [
        {
            name: 'Case ID',
            width: '200px',
            key: 'CaseId',
            template: (row) => {
                return(
                    <a className="fw-semibold" target="_blank" href= {`/ai-chatbot/support-case/case-details/${row.CaseId}`}> {row.CaseId} </a>
                )
            }
        },
        {
            name: 'Subject',
            width: '200px',
            key: 'Subject'
        },
        {
            name: 'Case Type',
            width: '200px',
            key: 'CaseType'
        },
        {
            name: 'Case Status',
            width: '200px',
            key: 'CaseStatus'
        },
        {
            name: 'Created Date',
            width: '100px',
            key: 'ArticleTypeName',
            template: (row) => {
                return (
                  <span>{format(new Date(row.CreatedDate), "dd-MM-yyyy")}</span>
                )
            }
        }
    ],
    url: "/support-cases/user/paged"
}

function SupportCase(){
    const [showModal, setShowModal] = useState(false);
    const [reloadTable, setReloadTable] = useState(false);
    const chatWindowRef = useRef(null);

    const {
        register,
        handleSubmit,
        reset,
        watch,
        formState: { errors }
    } = useForm();

    const caseContactTypeId = watch("CaseContactTypeId");

    const handleCloseModal = () => {
        reset({
            CaseTypeId: 1,
            Subject: "",
            Descriptions: "",
            CaseContactTypeId: 1,
            PhoneNumber: ""
        })
        setShowModal(false);
    }

    const onSubmitFrom = (data) => {
        const caseId = generateCaseId(15);
        data["CaseId"] = caseId;
        SupportCaseAPI.insert(data)
            .then(res => {
                if(res.data?.Success){
                    newWindowsChat(caseId);
                    setReloadTable(prev => !prev)
                }
                else{
                    toast.error(<span className="fs-9 fw-bold">An error occurred while adding your support case.</span>)
                }
            })
            .catch(err => {
                toast.error(<span className="fs-9 fw-bold">An error occurred while adding your support case.</span>)
            })
            .finally(() => {
                handleCloseModal();
            })
    }

    const generateCaseId = (length) =>
    {
        const array = new Uint8Array(length);
        window.crypto.getRandomValues(array);
        const chars = Array.from(array, byte => (byte % 10).toString());
        return chars.join('');
    }

    const newWindowsChat = (caseId) => {
        if(!caseId) return;
        if (chatWindowRef.current && !chatWindowRef.current.closed) {
            chatWindowRef.current.close();
        }
        const width = 400;
        const height = 700;
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
        const newWindow = window.open(
            `support-case/user/livechat/${caseId}`,
            '_blank',
            `width=${width},height=${height},top=${top},left=${left},resizable=no`
        );
        chatWindowRef.current = newWindow;
        if (newWindow) newWindow.focus();
    }

    return (
        <Fragment>
            <WelcomeToSession bodyEmphasis={false} screen="Support Case"/>
            <button type="button" className="btn btn-bt-primary mb-3 mt-5" onClick={() => setShowModal(true)}>Create New Support Case</button>
            <TablePaging tablePagingConfig={tablePagingConfig} reloadTable={reloadTable}/>
            <CenteredModal show={showModal}
                           onClose={handleCloseModal}
                           title="Add Support Case"
                           formId="formAddSupportCase"
                           modalType="modal-lg"
            >
                <form onSubmit={handleSubmit(onSubmitFrom)} id="formAddSupportCase">
                    <div className="mb-3">
                        <div>
                            <div className="mb-2"><span className="fs-8-1 fw-semibold">Choose the related issue for your case</span></div>
                            <div className="form-check form-check-inline">
                                <input id="rad1"
                                       className="form-check-input"
                                       type="radio"
                                       value = {1}
                                       defaultChecked
                                       {...register("CaseTypeId")}
                                />
                                <label title="" htmlFor="rad1" className="form-check-label">Account And Billing</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input id="rad2"
                                       className="form-check-input"
                                       type="radio"
                                       value = {2}
                                       {...register("CaseTypeId")}
                                />
                                <label title="" htmlFor="rad2" className="form-check-label">Technical</label>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <FormInput showHeaderLabel={true}
                                   name = "Subject"
                                   errors={errors}
                                   required={true}
                                   label="Assign Subject"
                                   validation={{...register("Subject", {
                                           required: 'Subject is required.'
                                       })}}
                        />
                    </div>
                    <div className="mb-3">
                        <FormInput showHeaderLabel={true}
                                   name = "Description"
                                   errors={errors}
                                   textarea={true}
                                   required={true}
                                   label="Assign Description"
                                   validation={{...register("Description", {
                                           required: 'Description is required.'
                                       })}}
                        />
                    </div>
                    <div className="mb-3">
                        <div>
                            <div className="mb-2"><span className="fs-8-1 fw-semibold">Contact us via</span></div>
                            <div className="form-check form-check-inline">
                                <input id="rad3"
                                       className="form-check-input"
                                       type="radio"
                                       value = {1}
                                       defaultChecked
                                       {...register("CaseContactTypeId")}
                                />
                                <label title="" htmlFor="rad3" className="form-check-label">Web chat (Online)</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input id="rad4"
                                       className="form-check-input"
                                       type="radio"
                                       value = {2}
                                       {...register("CaseContactTypeId")}
                                />
                                <label title="" htmlFor="rad4" className="form-check-label">Phone</label>
                            </div>
                        </div>
                    </div>
                    {
                        caseContactTypeId == 2 && (
                            <div className="mb-3">
                                <FormInput showHeaderLabel={true}
                                           name = "PhoneNumber"
                                           errors={errors}
                                           required={true}
                                           maxLengthText=""
                                           label="Assign PhoneNumber"
                                           validation={{...register("PhoneNumber", {
                                                   required: "Phone number is required.",
                                                   validate: (value) => {
                                                       const phoneNumber = parsePhoneNumberFromString(value);
                                                       if (!phoneNumber) return "Invalid phone number format. Example: +1 415 555 2671";
                                                       if (!phoneNumber.isValid()) return "Phone number is not valid. Example: +84 912 345 678";
                                                       return true;
                                                   },
                                               })}}
                                />
                            </div>
                        )
                    }
                </form>
            </CenteredModal>
        </Fragment>
    )
}

export default SupportCase;